import { ReactNode } from 'react';

import { OverlayContent, OverlayContentProps } from './OverlayContent';
import { Button } from '../../buttons';
import { HexIcon } from '../../hex-icons';
import * as Icons from '../../icons';
import { useDrawerOverlay } from '../DrawerOverlayProvider';

type Props = { error?: ReactNode; title?: ReactNode } & Omit<
  OverlayContentProps,
  'title'
>;

export const FailedToSaveOverlay = ({ error, ...rest }: Props) => {
  const { destroyOverlay } = useDrawerOverlay();
  return (
    <OverlayContent
      icon={<HexIcon variant="error" icon={<Icons.Warning />} />}
      title="Failed to save changes"
      body={
        error || (
          <>
            Something went wrong.
            <br />
            Please try again.
          </>
        )
      }
      actions={
        <Button
          variant="text"
          size="lg"
          startIcon={<Icons.ArrowClockwise />}
          onClick={destroyOverlay}
          testId="try-again-btn"
        >
          Try again
        </Button>
      }
      testId="failed-to-save-overlay"
      {...rest}
    />
  );
};
